var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubTicketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#17B65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39 6.23C5.39 4.95 6.45 4.06 7.99 4.06C9.47 4.06 10.41 4.88 10.45 6.2H9.17C9.14 5.57 8.69 5.2 7.97 5.2C7.18 5.2 6.67 5.58 6.67 6.19C6.67 6.71 6.95 7 7.56 7.14L8.71 7.39C9.96 7.66 10.57 8.3 10.57 9.39C10.57 10.75 9.51 11.63 7.9 11.63C6.34 11.63 5.32 10.8 5.29 9.49H6.57C6.58 10.11 7.08 10.48 7.9 10.48C8.75 10.48 9.29 10.11 9.29 9.5C9.29 9.01 9.04 8.72 8.44 8.59L7.28 8.33C6.04 8.06 5.39 7.35 5.39 6.23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubTicketIcon);
export default __webpack_public_path__ + "static/media/sub-ticket-icon.5d8b94f3ed86de6153c412867673a580.svg";
export { ForwardRef as ReactComponent };